import { FuelBottomSheet, FuelDialog } from '@frete.com/fuel-station-react';
import React, { useContext, useEffect, useState, useRef } from 'react';
import AppContext from '@context';
import useAmplitude from '@hooks/useAmplitude';
import Form from './Form';
import * as Styled from './DialogCancelJourneyStyles';
import { DialogCancelJourneyPropsInterface } from './DialogCancelJourneyTypes';

function DialogCancelJourney({
  isMobile,
}: Readonly<DialogCancelJourneyPropsInterface>) {
  const {
    state: { ui },
    dispatch,
  } = useContext(AppContext);
  const [isLoading, setIsLoading] = useState(false);
  const { amplitudeEvent } = useAmplitude();
  const { isShow } = ui.DialogCancelJourney;
  const confirmText = 'Cancelar viagem';
  const refuseText = 'Fechar';
  const formRef = useRef<HTMLFormElement | null>(null);
  const onClose = () => {
    dispatch({
      type: 'ui_dialogCancelJourney_set_show',
      payload: {
        isShow: false,
        journeyId: '',
        depositFee: {
          tagLabel: '',
        },
      },
    });
  };

  useEffect(() => {
    if (isShow && !isMobile) {
      document.body.classList.add('journey--overflowYHidden');
    }
    return () => {
      document.body.classList.remove('journey--overflowYHidden');
    };
  }, [isShow, isMobile]);

  const handleSubmitForm = () => {
    formRef.current?.dispatchEvent(
      new Event('submit', { cancelable: true, bubbles: true }),
    );

    amplitudeEvent('journey_confirm_canceled_modal');
  };

  return (
    <>
      <FuelBottomSheet
        title="Por qual motivo esta viagem será cancelada?"
        confirmText={confirmText}
        isOpen={isShow && isMobile}
        onClose={() => onClose()}
        refuseText={refuseText}
        onConfirm={() => {
          handleSubmitForm();
        }}
        onRefuse={() => onClose()}
        isLoading={isLoading}
        portalName="journey-bottomSheet-cancel-journey"
        height={480}
        zIndex={1001}
      >
        <Styled.WrapperMobile>
          <Form innerRef={formRef} hasLoading={setIsLoading} />
        </Styled.WrapperMobile>
      </FuelBottomSheet>

      <FuelDialog.Root
        showCloseButton
        isOpen={isShow && !isMobile}
        onClose={() => onClose()}
        portalName="portal-dialog-cancel-journey"
        width="md"
      >
        <FuelDialog.Header>
          Por qual motivo esta viagem será cancelada?
        </FuelDialog.Header>
        <FuelDialog.Body>
          <Form innerRef={formRef} hasLoading={setIsLoading} />
        </FuelDialog.Body>
        <FuelDialog.Footer>
          <FuelDialog.Action
            variant="tertiary"
            size="large"
            onClick={() => onClose()}
            fullWidth
          >
            {refuseText}
          </FuelDialog.Action>
          <FuelDialog.Action
            variant="primary"
            size="large"
            onClick={() => handleSubmitForm()}
            fullWidth
            isLoading={isLoading}
          >
            {confirmText}
          </FuelDialog.Action>
        </FuelDialog.Footer>
      </FuelDialog.Root>
    </>
  );
}
export default DialogCancelJourney;
